export class BaseResponse {
	constructor(public message: string) {}

	/**
	 * Validate that a response.message is the same as validMessage
	 *
	 * @param response
	 * @param validMessage
	 */
	public static validResponseMessage(
		response: BaseResponse,
		validMessage: string
	): boolean {
		return (
			response &&
			response.message &&
			response.message.localeCompare(validMessage) === 0
		);
	}
}
